import React from "react"

const CustomTotal = (from: number, to: number, size: number) => (
    <span className="react-bootstrap-table-pagination-total">
        {from} - {to} <span className="total-size"> of {size} </span>
    </span>
)
export default CustomTotal
